<ngx-spinner></ngx-spinner>
<div *ngIf="isTokenValidated">

  <header>
    <div class="header-container">
      <div class="dmbr-logo">
        <span class="dmbr">Maintenance e-book</span>
      </div>
    </div>
  </header>

  <div>



    <div class="vehicle-info-box">
      <app-vehicle-info [isAdditionalInfoUpdated]="isAdditionalInfoUpdated" (onVeichleUpdate)=onVeichleUpdate($event)></app-vehicle-info>
    </div>
    <div style="background-color: #F9F9F9;">
      <div style="margin: 0 45px 0 45px;">
        <mat-tab-group #tabGroup [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event)"  (selectedTabChange)="onTabChange($event)">

          <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tranlabel[index]">

            <app-service-history (addNewTab)=onAddNewTab($event) [isShTabSelected]="isShTabSelected" (shscrolled)=shScrolled($event) [reloadFirstTab]="reloadFirstTab"
              (onserviceHistoryReload)="reloadServiceHistory($event)" (additionInfoUpdated) = "onAdditionInfoUpdated($event)"
              *ngIf="tab ==='Service History' && selectedTab === 0" label="Service History"></app-service-history>

            <app-maintenance-plan [isVehicleInfoUpdated]="isVehicleInfoUpdated" [isMaintenanceTabSelected]="isMaintenanceTabSelected"
              (onMaintenanceReload)=onMaintenanceReload($event) (onaddServiceReload)="reloadServiceHistory($event)" (additionInfoUpdated) = "onAdditionInfoUpdated($event)"
              *ngIf="tab ==='Maintenance Schedule & Current Service'" label="Maintenance Schedule & Current Service"
              (switchToFirst)="onSwitchToFirst($event)"></app-maintenance-plan>

            <app-service-history-edit *ngIf="tab ==='Edit Service History'" label="Edit Service History"
              [newtabdata]="newtabdata" (removeTab)=removeTab($event) (switchToFirst)="onSwitchToFirst($event)">
            </app-service-history-edit>


          </mat-tab>

        </mat-tab-group>

      </div>
    </div>
  </div>

</div>